import {
  SALES_REGISTER_REPORT_REQUEST,
  SALES_REGISTER_REPORT_SUCCESS,
  SALES_REGISTER_REPORT_FAILURE,

  GET_ACCOUNTS_OF_SALES_BILL_REQUEST,
  GET_ACCOUNTS_OF_SALES_BILL_REQUEST_FAILURE,
  GET_ACCOUNTS_OF_SALES_BILL_SUCCESS,

  GET_ITEMS_OF_SALES_BILL_REQUEST,
  GET_ITEMS_OF_SALES_BILL_REQUEST_FAILURE,
  GET_ITEMS_OF_SALES_BILL_SUCCESS,

  GET_BROKERS_OF_SALES_BILL_REQUEST,
  GET_BROKERS_OF_SALES_BILL_REQUEST_FAILURE,
  GET_BROKERS_OF_SALES_BILL_SUCCESS,

  GET_SALE_BILLS_INVOICE_NUMBER_OF_SALES_BILL_REQUEST,
  GET_SALE_BILLS_INVOICE_NUMBER_OF_SALES_BILL_SUCCESS,
  GET_SALE_BILLS_INVOICE_NUMBER_OF_SALES_BILL_REQUEST_FAILURE,

  GET_LOTS_OF_SALES_BILL_REQUEST,
  GET_LOTS_OF_SALES_BILL_REQUEST_FAILURE,
  GET_LOTS_OF_SALES_BILL_SUCCESS,

  SALES_REGISTER_REPORT_REQUEST_SUCCESS,
  SALES_REGISTER_REPORT_REQUEST_FAILURE
} from "../types/sales-report-types";

const initialState = {
  salesReports: {},
  accountsOfSaleBill: {},
  itemsOfSaleBill: {},
  brokersOfSaleBill: {},
  lotsOfSaleBill: {},
  salesRegisterReport: {},
  saleBillsInvoiceNumberOfSaleBill: {},
  loading: false,
  error: null,
};

const salesReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case SALES_REGISTER_REPORT_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case SALES_REGISTER_REPORT_SUCCESS: {
      console.log('Sales Register Report Success Payload>>>', action);
      return {
        ...state,
        salesRegisterReport: { ...(action.payload || {}) },
        loading: false,
        error: null
      };
    }
    case SALES_REGISTER_REPORT_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }
    case SALES_REGISTER_REPORT_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case SALES_REGISTER_REPORT_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    case GET_ACCOUNTS_OF_SALES_BILL_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case GET_ACCOUNTS_OF_SALES_BILL_SUCCESS: {
      return {
        ...state,
        accountsOfSaleBill: { ...(action.payload || {}) },
        loading: false,
        error: null
      };
    }
    case GET_ACCOUNTS_OF_SALES_BILL_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }

    case GET_ITEMS_OF_SALES_BILL_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case GET_ITEMS_OF_SALES_BILL_SUCCESS: {
      return {
        ...state,
        itemsOfSaleBill: { ...(action.payload || {}) },
        loading: false,
        error: null
      };
    }
    case GET_ITEMS_OF_SALES_BILL_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }

    case GET_BROKERS_OF_SALES_BILL_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case GET_BROKERS_OF_SALES_BILL_SUCCESS: {
      return {
        ...state,
        brokersOfSaleBill: { ...(action.payload || {}) },
        loading: false,
        error: null
      };
    }
    case GET_BROKERS_OF_SALES_BILL_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }

    case GET_LOTS_OF_SALES_BILL_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case GET_LOTS_OF_SALES_BILL_SUCCESS: {
      return {
        ...state,
        lotsOfSaleBill: { ...(action.payload || {}) },
        loading: false,
        error: null
      };
    }
    case GET_LOTS_OF_SALES_BILL_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }

    case GET_SALE_BILLS_INVOICE_NUMBER_OF_SALES_BILL_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case GET_SALE_BILLS_INVOICE_NUMBER_OF_SALES_BILL_SUCCESS: {
      return {
        ...state,
        saleBillsInvoiceNumberOfSaleBill: { ...(action.payload || {}) },
        loading: false,
        error: null
      };
    }
    case GET_SALE_BILLS_INVOICE_NUMBER_OF_SALES_BILL_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }
    default:
      return state;
  }
};

export default salesReportReducer;